<template>
  <div class="wrapper">
    <!-- <div class="storeInfoWrap" v-if="storeInfo.nbr">
      <div class="storeInfo">
        <div class="storeLeft">
          <img :src="storeInfo.logo" alt=""/>
          <div class="storeRight">
            <span class="title">{{storeInfo.supplier_name}}</span>
            <span class="quantity">在售商品{{storeInfo.quantity}}件</span>
          </div>
        </div>
      </div>
    </div> -->
    <div class="desc">
      <span class="descText">由本商家自行发货及售后处理</span>
    </div>
    <div class="searchPage">
      <div class="searchlist-t">
        <div class="searchlist-tl" @click="sort(1)" :class="currentindex==1?'active':''"><span>默认</span></div>
        <div class="searchlist-tl" @click="sort(2)" :class="currentindex==2?'active':''"><span>最新</span></div>
        <!-- <div class="searchlist-tl" @click="sort(3)" :class="currentindex==3?'active':''">
          <span>销量</span>
          <img src="../../assets/images/search/icon1.svg" alt v-if="currentindex!=3">
          <img src="../../assets/images/search/icon2.svg" alt v-if="currentindex==3&&sortOrder=='2'">
          <img src="../../assets/images/search/icon3.svg" alt v-if="currentindex==3&&sortOrder=='1'">
        </div> -->
        <div class="searchlist-tl" @click="sort(4)" :class="currentindex==4?'active':''">
          <span>价格</span>
          <img src="../../assets/images/search/icon1.svg" alt v-if="currentindex!=4">
          <img src="../../assets/images/search/icon2.svg" alt v-if="currentindex==4&&sortOrder=='2'">
          <img src="../../assets/images/search/icon3.svg" alt v-if="currentindex==4&&sortOrder=='1'">
        </div>
        <div  class="searchlist-tlr" @click="vary">
          <img :src="require(`../../assets/images/search/change${style}.svg`)" alt="" >
        </div>
     </div>
    </div>
    <div class="home-content-tab">
      <van-list
        class="tabbox"
        v-model="loading"
        :finished="finished"
        @load="loadMore"
        :offset="20"
        id="scroll"
      >
        <van-pull-refresh v-model="isLoading" @refresh="refresh">
          <div :class="style == 1?'refresh1':'refresh'">
            <img @click="toAreaCoupon" class="areaImg" :src="coupon_image" alt="" v-if="coupon_image" />
            <div
              class="tabboxm"
              v-for="(item,index) in goods_list"
              :key="index"
              @click="golistdetail(item.nbr)"
            >
              <div class="tabboxmt">
                <img v-lazy="item.commodity_logo + `${imgCrop}resize,w_500`" alt />
                <div :class="item.quantity==='0'?'noNum':'noNum hide'">
                  <img v-lazy="require('../../assets/images/noNum.png')" alt />
                </div>
              </div>
              <div class="right">
                <div class="bottomArea"  v-if="style==2">
                  <img v-if="item.start_state == 0" class="beSale" src="../../assets/images/beSale.png" alt="">
                </div>
                <div class="right-top">
                  <div class="tanboxmm1 sigle-h">{{item.commodity_name}}</div>
                  <div :class="item.is_use_coupon=='0'?'tanboxmbb hide':'tanboxmbb'" v-if="style==1">
                    <span>可使用优惠券</span>
                    <div class="bottomArea">
                      <img v-if="item.start_state == 0" class="beSale" src="../../assets/images/beSale.png" alt="">
                    </div>
                  </div>
                  <div class="commoditySummary sigle-h" :style="item.commodity_summary?{background:'#FFF0B0'}:{background:'transparent'}">{{item.commodity_summary}}</div>
                </div>
                <div class="right-bottom">
                  <div class="tanboxmb">
                    <span>
                      <i>￥</i>{{item[`min_${roleText}_price`]}}
                    </span>
                    <span v-if="parseFloat((item[`min_sell_price`]-item[`min_${roleText}_price`]).toFixed(2)) != 0">
                      <!--/<i> 赚￥</i>{{parseFloat((item[`min_sell_price`]-item[`min_${roleText}_price`]).toFixed(2))}}-->
                    </span>
                    <div class="tanboxmbbb">￥{{item.old_price}}</div>
                    <div  v-if="style==2" :class="item.is_use_coupon=='0'?'tanboxmbb hide':'tanboxmbb'">可用券</div>
                  </div>
                </div>
                  <!-- <div class="tanboxmm2 more-h" style=" -webkit-box-orient: vertical;">
                      {{item.describe}}
                  </div>-->
              </div>
            </div>
            <div class="nomore" v-show="finished==true && goods_list.length != 0">没有更多了^v^</div>
          </div>
        </van-pull-refresh>
      </van-list>
    </div>
    <div class="poBtnArea">
      <div class="toTop" @click="toTopAnimate" v-show="toTopShow">
        <img src="../../assets/images/index/top.svg" />
      </div>
    </div>
  </div>
</template>

<script>
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      //first_classify: [],
      storeInfo: {},
      nbr: "", // 专区nbr
      goods_list: [], //商品
      //classifyindexid: "", //下标id
      loading: false, //上拉加载
      finished: false, //加载完成
      pageIndex: 0,
      totalRows: 0,
      numPerPage: 10,
      roleText: "sell",
      keepAlive: true,
      isLoading: false,
      scroll: 0,
      active: 0,
      title: "",
      toTopShow:false,
      currentindex:"1",
      style:"2",
      sortType: "0",
      sortOrder: "1",
      isLogin:0,
      option:{},
      shareShow:false,
      htmlUrl:'',
      info:{},
      qrCode:'',
      backImg:'',
      coupon_image:''
    };
  },
  watch: {
    $route(to, from) {
      if (
        from.path == "/listdetail" ||
        from.path == "/placeorder" ||
        from.path == "/index"
      ) {
        this.keepAlive = true;
      } else {
        this.keepAlive = false;
      }
    }
  },
  computed: {
  },
  methods: {
    checkOption(){
      if(!(this.userInfo&&this.userInfo.nbr)){
        let option = {
          title: '我的店铺',
          desc: "欢迎光临我的店铺",
          link: location.origin,
          images: this.cdnImgPath + '/images/default/wx_head_default.jpg',
        }
        this.weChatShare(option);
        this.isLogin = 0;
        this.roleText = 'Sell';
      }else{
        let option = {
        title: '有米@'+this.userInfo.name + "的店铺",
        desc: "欢迎光临我的店铺",
        link: location.origin + "/?supNbr=" + this.userInfo.nbr,
        images: this.userInfo.imgUrl
        };
        this.weChatShare(option);
        this.isLogin = 1;
      }
    },
    vary(){
      if(this.style==2){
        this.style = 1;
      }else{
        this.style = 2;
      }
    },
    refresh() {
      this.finished = true;
      this.pageIndex = 0;
      this.getData([]);
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    golistdetail(nbr) {
      this.$router.push({ path: "/listdetail", query: { nbr: nbr,supNbr:this.userInfo.nbr } });
    },
    loadMore() {
      if (this.finished) {
        return false;
      }
      if (this.totalRows > (this.pageIndex + 1) * this.numPerPage) {
        this.loading = true;
        this.pageIndex++;
        this.getData(this.goods_list);
      }
    },
     sort(index) {
      this.finished = false;
      let currentindex = this.currentindex;
      let sortType = this.sortType,
      sortOrder = this.sortOrder;
      switch (index) {
        case 1:
          sortType = "0";
          sortOrder = "1";
          break;
        case 2:
          sortType = "3";
          sortOrder = "2";
          break;
        case 3:
          sortType = "2";
          if (currentindex != index) {
            sortOrder = "2";
          } else {
            sortOrder = sortOrder == "2" ? "1" : "2";
          }
          break;
        case 4:
          sortType = "1";
          if (currentindex != index) {
            sortOrder = "1";
          } else {
            sortOrder = sortOrder == "1" ? "2" : "1";
          }
          break;
        default:
          sortType = "0";
          sortOrder = "1";
      }

      this.currentindex = index;
      this.sortType = sortType;
      this.sortOrder = sortOrder;
      this.pageIndex = 0;
      this.goods_list = [];
      this.getData([]);
    },
    getData(oldList) {
      this.goods_list = oldList;
      this.$commonPost({
        jydm: "flow_70001",
        flow_70001: {
          nbr: this.nbr,
          sort_type: this.sortType,
          sort_order: this.sortOrder,
          page_index: this.pageIndex * this.numPerPage,
          num_per_page: this.numPerPage,
          commodity_name: "",
          commodity_nbr: this.commodityNbr,
        }
      })
        .then(response => {
          let arr = [];
          if (response.commodityList && response.commodityList.commodity) {
           if (response.commodityList.commodity.length > 0) {
              arr = response.commodityList.commodity;
            } else {
              arr.push(response.commodityList.commodity);
            }
          }
          
          this.goods_list = oldList.concat(arr);
          this.totalRows = response.total_rows;
          this.loading = false;
          if (arr.length < this.numPerPage) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    handleScroll(){
      // 设备/屏幕高度
      let scrollTop = document.getElementById("scroll").scrollTop;
      if(scrollTop > 50){
        this.toTopShow = true;
      }else{
        this.toTopShow = false;
      }
    },
    // 回到顶部动画
    toTopAnimate(){
      document.getElementById("scroll").scrollTop = 0;
    },
    getUserInfo(){
      // 用户的基本信息(身份)
      this.$commonPost({
        jydm: "flow_10003",
        flow_10003: {
          user_nbr: this.userInfo.nbr
        }
      })
        .then(response => {
          this.info = response;
          if (response.role == 0||response.role == 1) {
            this.roleText = "sell";
          } else if (response.role == 2) {
            this.roleText = "agent";
          } else if (response.role == 3) {
            this.roleText = "director";
          }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
     },
  },
  created() {
  },
  mounted() {
  },
  // 被缓存时任执行
  activated() {
    document.getElementById("scroll").addEventListener('scroll', this.handleScroll, true);
    document.title = decodeURIComponent(this.$route.query.name);
    this.commodityNbr = this.$route.query.commodityNbr
    if (!this.keepAlive) {
      //将高度滚动到原来离开页面的高度
      document.getElementById("scroll").scrollTop = this.scroll;
      return false;
    } else {
      let that = this;
      this.pageIndex = 0;
      this.nbr = this.$route.query.nbr;
      this.getData([]);
    }
    this.checkOption();

    // 店铺信息
    this.$commonPost({
      jydm: "flow_70218",
      flow_70218: {
        nbr: this.commodityNbr,
      },
    })
      .then((response) => {
        this.storeInfo = response.nbr?response:{};
      })
      .catch((err) => {
        this.$toast({
          message: err.message,
          duration: 2000,
        });
      });
  },
  beforeRouteLeave(to, from, next) {
    this.scroll = document.getElementById("scroll").scrollTop;
    document.getElementById("scroll").removeEventListener('scroll', this.handleScroll,true);
    next();
  }
};
</script>
<style scoped lang='stylus'></style>
<style scoped lang='less'>
.storeInfoWrap{
  width: 100%;
}
.desc{
  width: 100%;
  padding-bottom: .2rem;
  height: .4rem;
  background: #fff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  .descText{
    font-size: 0.28rem;
    font-weight:500;
    color: #999;
  }
}
.storeInfo{
  background: #fff;
  width: 100%;
  height: 1.36rem;
  box-sizing: border-box;
  padding: .2rem .24rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .storeLeft{
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    img{
      width: 1rem;
      height: 1rem;
      margin-right:.2rem
    }
    .storeRight{
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      .title{
        font-size: 0.3rem;
        font-weight:bold;
        color: #333;
        line-height: .42rem;
        max-width: 4rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        word-break: break-all;
        white-space: normal;
      }
      .quantity{
        font-size: 0.24rem;
        font-weight:500;
        color: #999;
        margin-top: .18rem;
        line-height: .34rem;
      }
    }
  }
}
.searchPage{
  width: 100%;
  .scroll{
    height: calc(100vh - 1.28rem);
    overflow-y: scroll;
    width: 100%;
  }
  .scroll::-webkit-scrollbar {
     display: none;
  }
}
.searchlist-t {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 0.28rem;
  z-index: 9;
  background: #fff;
  width: 100%;
  height: .68rem;
}
.searchlist-tl{
  flex:1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
  transform: scale(0.5);
  img{
    width: .28rem;
    height: .36rem;
    margin-left: .08rem;
  }
  span{
    line-height:.68rem;
    font-size: 0.48rem;
  }
  
}
.searchlist-tlr{
  width:0.78rem;
  display: flex;
  justify-content: center;
  align-items: center;
  img{
    width:0.3rem;
    height:0.3rem;
  }
}
.active {
  font-weight: 700;
  color: #333 !important;
}
.poBtnArea{
  position: fixed;
  left: 6.08rem;
  z-index: 999;
  bottom: 2rem;
  text-align: right;
}
.toTop{
  width: .8rem;
  height: 0.8rem;
  margin-top: .3rem;
  background: rgba(51,51,51,0.5);
  text-align: center;
  line-height: .8rem;
  border-radius:50%;
  display: inline-block;
}
.toTop img{
  width: 0.4rem;
  height: 0.4rem;
}
.hide {
  display: none !important;
}
.wrapper {
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
}
.tabbox {
  height: calc(100vh - 1.28rem);
  overflow-y: scroll;
  -webkit-overflow-scrolling:touch;
  width: 100%;
}
.refresh {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  background:#fff;
  .tabboxm:nth-of-type(2n) {
    margin-left: 0.18rem;
  }
  .tabboxm:nth-of-type(2n + 1) {
    margin-left: 0.23rem;
  }
  .tabboxm {
    margin-top: 0.24rem;
    width: 3.43rem;
    height: 5.8rem;
    background: #FFFFFF;
    border: 1px solid #DDDDDD;
    border-radius: 0.16rem;
    position: relative;
    overflow: hidden;
    .tabboxmt{
       width: 100%;
      height: 3.42rem;
      box-sizing: border-box;
      border-bottom: 1px solid #ddd;
      position: relative;
      overflow: hidden;
      .noNum {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        background: rgba(51, 51, 51, 0.3);
        width: 100%;
        height: 3.42rem;
        img{
          width: 75%;
          height: 60%;
        }
      }
      img{
        width: 100%;
        height: 3.42rem;
        object-fit: cover;
      }
    }
    .tanboxmm1 {
      line-height: 0.32rem;
      margin: 0 0.1rem;
      font-size: 0.24rem;
      margin-top: 0.22rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;
      white-space: normal;
      height:0.62rem;
    }
    .tanboxmb {
      margin-top: 0.15rem;
      line-height: 0.4rem;
      overflow: hidden;
      span i {
        font-size: 0.24rem;
        font-weight: bold;
      }
      span:nth-of-type(1) {
        color: #333333;
        font-size: 0.3rem;
        margin-left: 0.1rem;
        font-weight: bold;
      }
      span:nth-of-type(2) {
        color: #E52B25;
        font-size: 0.24rem;
        font-weight: bold;
      }
    }
    .tanboxmbbb{
      color: #666;
      margin-left: 0.1rem;
      font-size:0.24rem;
      text-decoration: line-through;
      line-height: 0.34rem;
      margin-top: 0.02rem;
    }
    .tanboxmbb {
      width:0.9rem;
      height:0.31rem;
      color: #f53547;
      font-size: 0.2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background:url(../../assets/images/FFF1F2.png) no-repeat;
      background-size:0.9rem 0.3rem;
      position: absolute;
      right: 0;
      bottom: 0.14rem;
    }
    .bottomArea{
      position: relative;
      .beSale{
        width: 1.16rem;
        height: .3rem;
        position: absolute;
        top: -0.36rem;
        left: 0.1rem;
      }
    }
    .commoditySummary{
      max-width: 3rem;
      color: #FF3500;
      font-size: 0.2rem;
      font-weight: 500;
      line-height: 1.5;
      height: 0.26rem;
      margin: 0.12rem .1rem 0;
      background: #FFF0B0;
      padding: 0.04rem 0.1rem;
      border-radius: 0.04rem;
      display: inline-block;
    }
  }
}
.refresh1 {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #fff;
  .tabboxm {
    margin:0;
    width: 100%;
    height: 2.8rem;
    padding:.2rem .24rem;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    .tabboxmt{
       position: relative;
      .noNum {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        background: rgba(51, 51, 51, 0.3);
        width: 100%;
        height: 2rem;
        border-radius: .08rem;
        img{
          width: 75%;
          height: 60%;
        }
      }
      img{
        width: 2.4rem;
        height: 2.4rem;
        border-radius: .08rem;
      }
    }
    .commoditySummary{
       color: #FF3500;
      font-size: 0.2rem;
      font-weight: 500;
      margin: 0.12rem 0 0;
      background: #FFF0B0;
      padding: 0.04rem 0.1rem;
      border-radius: 0.04rem;
      display: inline-block;
      height: 0.26rem;
      max-width: 4.3rem;
      line-height: 1.5;
    }
    .right{
      width: calc(100% - 2.6rem);
      display: flex;
      flex-direction: column;
      justify-content: start;
      height: 100%;
      position: relative;
      .bottomArea{
        margin-left:0.1rem;
        .beSale{
          width: 1.16rem;
          height: 0.3rem;
        }
      }
      .right-top{
        .tanboxmm1 {
          line-height: 0.32rem;
          height: .64rem;
          font-size: 0.24rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-break: break-all;
          white-space: normal;
        }
        .tanboxmbb {
          margin-top:0.18rem;
          height: 0.3rem;
          line-height: 0.3rem;
          display: flex;
          align-items: center;
          border-radius: .04rem;
          margin-right: .14rem;
          span{
            background: #FFF1F2;
            font-size: .2rem;
            color: #F53547;
            line-height: 0.3rem;
            padding: 0 0.12rem;
          }
        }
      }
      .right-bottom{
        margin-top:0.1rem;
         .tanboxmb {
          line-height: 0.4rem;
          overflow: hidden;
          span i {
            font-size: 0.2rem;
            font-weight: bold;
          }
          span:nth-of-type(1) {
            color: #333333;
            font-size: 0.3rem;
            font-weight: bold;
          }
          span:nth-of-type(2) {
            color: #E52B25;
            font-size: 0.24rem;
            font-weight: bold;
          }
        }
        .tanboxmbbb{
          color: #666;
          font-size:0.24rem;
          text-decoration: line-through;
          line-height: 0.34rem;
          margin-top: 0.03rem;
        }
      }
    }
  }
}
.home-content-tab {
  position: fixed;
  top: 1.28rem;
  width: 100%;
}
.home-content-tabtop {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
}
.home-content-tabtop::-webkit-scrollbar {
  display: none;
}
.home-content-tabtopm {
  width: 1.08rem;
  height: 0.56rem;
  font-size: 0.28rem;
  line-height: 0.56rem;
  text-align: center;
}




.tanboxmm2 {
  line-height: 0.32rem;
  margin: 0 0.24rem;
  margin-top: 0.15rem;
  font-size: 0.22rem;
  color: #999;
}

.areaImg{
  width: 7.02rem;
  height: 1.7rem;
  margin: .1rem auto;
  object-fit: cover;
}


.nomore {
  width: 100%;
  text-align: center;
  color: #999999;
  line-height: 1rem;
  display: block;
}
</style>
<style lang="stylus" scoped>
.home-content-tab >>> .van-tabs__line {
  background-color: #5045D8 !important;
}
.home-content-tab >>> .van-pull-refresh{
  box-sizing:border-box;
  min-height: calc(100vh - 1.28rem);;
}
.home-content-tab >>> .van-tab--active {
  color: #5045D8 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/storeList.vue